"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounceClick = exports.resetAllowClick = exports.allowClick = void 0;
var lodash_1 = __importDefault(require("lodash"));
var slate_1 = require("slate");
var EditorTypes_1 = require("./EditorTypes");
var Utils_1 = require("./Utils");
var slate_react_1 = require("slate-react");
exports.allowClick = true;
exports.resetAllowClick = lodash_1.default.debounce(function () {
    exports.allowClick = true;
}, 500);
var debounceClick = function (editor, element) {
    return function (event) {
        var blocks = (0, Utils_1.getSelectedBlocks)(editor);
        var isFocused = document.activeElement === slate_react_1.ReactEditor.toDOMNode(editor, element);
        var isEmpty = element.text == "";
        var isCursorInBlock = blocks.length > 0 && blocks[0][0] === element;
        var isSingleBlock = blocks.length == 1;
        if (exports.allowClick) {
            exports.allowClick = false;
            (0, exports.resetAllowClick)();
        }
        else if (isFocused && isEmpty && isCursorInBlock && isSingleBlock && !inTable(editor, element)) {
            exports.resetAllowClick.cancel();
            (0, exports.resetAllowClick)();
            event.preventDefault();
        }
    };
};
exports.debounceClick = debounceClick;
var inTable = function (editor, element) {
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    var ancestors = slate_1.Path.ancestors(path);
    for (var i = 0; i < ancestors.length; i++) {
        var ancestor = slate_1.Editor.node(editor, ancestors[i]);
        if (ancestor[0].type == EditorTypes_1.BlockType.Table) {
            return true;
        }
    }
    return false;
};
